import { render, staticRenderFns } from "./lease-amendments.vue?vue&type=template&id=081b3060&lang=html&"
import script from "./lease-amendments.vue?vue&type=script&lang=js&"
export * from "./lease-amendments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports